import { Component, Input } from '@angular/core';
import { HintboxOptions } from '@inscomponents/core';
import { HintboxDirective } from '../hintbox/hintbox.directive';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import { IconComponent } from '../icon/icon.component';

export interface HelpInPlaceData {
    hintbox: HintboxData;
    tooltip: TooltipData;
}

type HintboxData = Partial<HintboxOptions>;
type TooltipData = string | string[];

@Component({
    selector: 'skl-help-in-place',
    templateUrl: './help-in-place.component.html',
    styleUrls: ['./help-in-place.component.scss'],
    imports: [HintboxDirective, TooltipDirective, IconComponent]
})
export class HelpInPlaceComponent {

    public hintboxData!: Partial<HintboxOptions>;
    public tooltipData!: TooltipData;

    @Input() public set data(value: HelpInPlaceData) {
        this.hintboxData = { autoPlacement: true, ...value?.hintbox };
        this.tooltipData = value.tooltip;
    }
}
